import { SelectField } from '@today/ui-components'
import { useTranslation } from 'react-i18next'
import { changeLanguage } from '@/i18n'
import { SUPPORTED_LANGUAGES, type SupportedLanguage } from '@/i18n/language'

/** Switches the customer screens' language immediately and remembers the choice (TO-418 customer-ui REQ-001). */
export function LanguageSelector() {
	const { t, i18n } = useTranslation()
	return (
		<SelectField
			className="w-40"
			label={t('language.label')}
			value={i18n.language}
			onValueChange={(value) => void changeLanguage(value as SupportedLanguage)}
			options={SUPPORTED_LANGUAGES.map((id) => ({ id, text: t(`language.${id}`) }))}
		/>
	)
}
